import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import AppErrorBoundary from "./AppErrorBoundary";
import { AppConfigProvider } from '../../shared/useAppConfig';
import AppRoutes from "./Routes"
import { BrowserRouter } from 'react-router-dom';
import MsalProviderHost from './MsalProviderHost';
import theme from '../../theme';

const App: React.FC = () => {

    return (
        <ThemeProvider theme={theme}>
            <div className="app">
                <AppErrorBoundary>
                    <AppConfigProvider>
                        <MsalProviderHost>
                            <BrowserRouter>
                                <AppRoutes />
                            </BrowserRouter>
                        </MsalProviderHost>
                    </AppConfigProvider>
                </AppErrorBoundary>
            </div>
        </ThemeProvider>
    );
}

export default App;
